
export default {
    name: 'addObject',
    title: '添加对象',
    component: () => import('../../../views/dialog/AddObject')
}
